export default __webpack_public_path__ + "static/media/radijatoraqua.9e1f1412.jpg";